// extracted by mini-css-extract-plugin
module.exports = {"main":"new__main___2NZEr","brand":"new__brand___Ynx88","empty":"new__empty___2iEYr","info":"new__info___3bOJD","btn":"new__btn___QEP_e","copyright":"new__copyright___1yJMI"};